// import { initializeApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'

// import { 
//   getFirestore,
//   collection,
//   getDocs,
//   query,
//   where,
//   collectionGroup,
//   deleteDoc, 
//   doc, 
//   updateDoc, 
//   getDoc, 
//   setDoc, 
//   limit, 
//   orderBy, 
//   writeBatch, 
//   addDoc,
//   documentId,
// } from 'firebase/firestore/lite'

import { 
  // getFirestore,
  collection,
  getDocs,
  query,
  where,
  collectionGroup,
  deleteDoc, 
  doc, 
  updateDoc, 
  getDoc, 
  setDoc, 
  limit, 
  orderBy, 
  writeBatch, 
  addDoc,
  documentId,
  onSnapshot,
  runTransaction
} from 'firebase/firestore'

import { getAuth, GoogleAuthProvider, EmailAuthProvider, deleteUser, updatePassword, signInAnonymously } from 'firebase/auth'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import { errorToast } from '../common/functions'
import { t } from 'i18next'
import { getStorage } from 'firebase/storage'
import { setMultiTab } from '../redux/global'
// const functions = getFunctions()

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
}

const app = firebase.initializeApp(firebaseConfig)
const firestore = firebase.firestore(app)
firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
})
const auth = getAuth(app)
const storage = getStorage()

firebase.firestore().enablePersistence()
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      setMultiTab()
      // errorToast({ message: t('messages.attentionMsg'), title: t('messages.attention'), autoHideDuration: 10000, closeIcon: true })
    } else if (err.code === 'unimplemented') {
      errorToast({ message: t('messages.unimplementedMsg'), title: t('Search.DeleteJob'), autoHideDuration: 3000 })
    }
  })

export { 
  firestore,
  httpsCallable,
  getFunctions,
  collection,
  getDocs,
  query,
  where,
  collectionGroup,
  deleteDoc, 
  doc, 
  updateDoc, 
  getDoc, 
  setDoc, 
  limit, 
  orderBy, 
  writeBatch, 
  addDoc,
  documentId, 
  auth, 
  GoogleAuthProvider, 
  EmailAuthProvider,
  deleteUser,
  updatePassword,
  signInAnonymously,
  storage,
  onSnapshot,
  runTransaction,
}
